import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import * as api from "../../common/athleteCommon/API";
import Utils from "../../common/athleteCommon/Utils";

interface Props {
    history: any;
}

const InjuryHistory: React.FC<Props> = ({ history }) => {

    const injuryTypeList = [{ injTypId: "1", injTypName: "Acute" }, { injTypId: "2", injTypName: "Overuse/Chronic" }, { injTypId: "3", injTypName: "Recurrent" }]
    const affectedRegionList = [{ aftcdRgnId: "1", aftcdRgnName: "Head" }, { aftcdRgnId: "2", aftcdRgnName: "Face" }, { aftcdRgnId: "3", aftcdRgnName: "Cervical Spine/ Neck" },
    { aftcdRgnId: "4", aftcdRgnName: "Shoulder" }, { aftcdRgnId: "5", aftcdRgnName: "Upper Arm" }, { aftcdRgnId: "6", aftcdRgnName: "Elbow" }, { aftcdRgnId: "7", aftcdRgnName: "Forearm" },
    { aftcdRgnId: "8", aftcdRgnName: "Wrist" }, { aftcdRgnId: "9", aftcdRgnName: "Hand/ Fingers" }, { aftcdRgnId: "10", aftcdRgnName: "Thoracic spine" }, { aftcdRgnId: "11", aftcdRgnName: "Lumbar Spine" },
    { aftcdRgnId: "12", aftcdRgnName: "Pelvis" }, { aftcdRgnId: "13", aftcdRgnName: "Hip" }, { aftcdRgnId: "14", aftcdRgnName: "Thigh" }, { aftcdRgnId: "15", aftcdRgnName: "Knee" }, { aftcdRgnId: "16", aftcdRgnName: "Lower Leg" }, { aftcdRgnId: "17", aftcdRgnName: "Ankle" }, { aftcdRgnId: "18", aftcdRgnName: "Foot/ toes" }]
    const diagnosisList = [{ diagnosisId: "1", diagnosisName: "Concussion" }, { diagnosisId: "2", diagnosisName: "Ligament Sprain" }, { diagnosisId: "3", diagnosisName: "Muscle Strain" }, { diagnosisId: "4", diagnosisName: "Tendinopathy" }, { diagnosisId: "5", diagnosisName: "Fracture" }, { diagnosisId: "6", diagnosisName: "Dislocation" }, { diagnosisId: "7", diagnosisName: "Subluxation" },
    { diagnosisId: "8", diagnosisName: "Contusion" }, { diagnosisId: "9", diagnosisName: "Nerve Injury" }, { diagnosisId: "10", diagnosisName: "Meniscus Injury" }, { diagnosisId: "11", diagnosisName: "Cartilage Injury" }, { diagnosisId: "12", diagnosisName: "Stress fracture" }]
    const severityList = [{ severityId: "1", severityName: "Mild" }, { severityId: "2", severityName: "Moderate" }, { severityId: "3", severityName: "Severe" }]
    const injuryMechanismList = [{ injMechId: "1", injMechName: "Contact" }, { injMechId: "2", injMechName: "Non-contact" }, { injMechId: "3", injMechName: "Overuse" }, { injMechId: "4", injMechName: "Collision" }, { injMechId: "5", injMechName: "Fall" }, { injMechId: "6", injMechName: "Equipment-related" }, { injMechId: "7", injMechName: "Environment-related" }]
    const injuryMgmtList = [{ injMgmtId: "1", injMgmtName: "RICE protocol" }, { injMgmtId: "2", injMgmtName: "Physiotherapy" }, { injMgmtId: "3", injMgmtName: "Medication" }, { injMgmtId: "4", injMgmtName: "Immobilization" }, { injMgmtId: "5", injMgmtName: "Injection Therapy" }, { injMgmtId: "6", injMgmtName: "Surgery" }, { injMgmtId: "7", injMgmtName: "Other" }]
    const timeLostList = [{ timelostId: "1", timelostName: "No time lost" }, { timelostId: "2", timelostName: "1 - 3 weeks" }, { timelostId: "3", timelostName: "3-6 weeks" }, { timelostId: "4", timelostName: "More than 6 weeks" }]

    const [injId, setInjId] = useState("");
    const [desc, setDesc] = useState("");
    const [injDate, setInjDate] = useState("");
    const [sprtDate, setSprtDate] = useState("");
    const [treatSmry, setTreatSmry] = useState("");
    const [recSmry, setRecSmry] = useState("");
    const [injTyp, setInjTyp] = useState("");
    const [rgnAfctd, setRgnAfctd] = useState([]);
    const [diagnosis, setDiagnosis] = useState([]);
    const [injSvrty, setInjSvrty] = useState("");
    const [injMech, setInjMech] = useState("");
    const [injMgmt, setInjMgmt] = useState([]);
    const [timeLost, setTimeLost] = useState("");
    const [status, setStatus] = useState("");
    const [injuryHistory, setInjuryHistory] = useState<any[]>([]);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        setInjuryHistory(history || [])
    }, [])

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function addRecord() {
        setIsEdit(false)
        setOpenModal(true)
        setInjTyp("")
        setDesc("")
        setInjDate("")
        setSprtDate("")
        setRecSmry("")
        setTreatSmry("")
        setRgnAfctd("")
        setDiagnosis("")
        setInjSvrty("")
        setInjMech("")
        setInjMgmt("")
        setTimeLost("")
    }

    function editDetails(details) {
        setIsEdit(true)
        setOpenModal(true)
        setInjId(details.injuryProfileId)
        setInjTyp(details.injuryType)
        setDesc(details.injuryDescription)
        setInjDate(details.dateOfInjury)
        setSprtDate(details.dateOfReturnToSports)
        setRecSmry(details.summaryOfRecoveryProcess)
        setTreatSmry(details.summaryOfTreatment)
        setRgnAfctd(details.regionAffected)
        setDiagnosis(details.diagnosis)
        setInjSvrty(details.injurySeverity)
        setInjMech(details.mechanismOfInjury)
        setInjMgmt(details.injuryManagementApproach)
        setTimeLost(details.timeLostFromTraining_Competition)
        setStatus(details.status)
    }

    function handleSubmit() {
        if (isEdit) {
            updateDetails();
        } else {
            const frmData = new FormData();
            frmData.append("injuryType", injTyp)
            frmData.append("injuryDescription", desc)
            frmData.append("dateOfInjury", injDate)
            frmData.append("dateOfReturnToSports", sprtDate)
            frmData.append("summaryOfTreatment", treatSmry)
            frmData.append("summaryOfRecoveryProcess", recSmry)
            frmData.append("regionAffected", rgnAfctd)
            frmData.append("diagnosis", diagnosis)
            frmData.append("injurySeverity", injSvrty)
            frmData.append("mechanismOfInjury", injMech)
            frmData.append("injuryManagementApproach", injMgmt)
            frmData.append("timeLostFromTraining_Competition", timeLost)
            const injryHstry = api.AddInjuryDetails;
            fetch(injryHstry, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: frmData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                            .then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                    // navigate(routes.manipurlogin)
                                }
                            });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                    }
                })
        }
    }

    function updateDetails() {
        const frmData = new FormData();
        frmData.append("injuryType", injTyp)
        frmData.append("injuryDescription", desc)
        frmData.append("dateOfInjury", injDate)
        frmData.append("dateOfReturnToSports", sprtDate)
        frmData.append("summaryOfTreatment", treatSmry)
        frmData.append("summaryOfRecoveryProcess", recSmry)
        frmData.append("regionAffected", rgnAfctd)
        frmData.append("diagnosis", diagnosis)
        frmData.append("injurySeverity", injSvrty)
        frmData.append("mechanismOfInjury", injMech)
        frmData.append("injuryManagementApproach", injMgmt)
        frmData.append("timeLostFromTraining_Competition", timeLost)
        const injryHstry = api.EditInjuryDetails + "/" + injId;
        fetch(injryHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: frmData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                        .then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                                // navigate(routes.manipurlogin)
                            }
                        });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row align-items-center">
                        <div className="d-flex justify-content-end">
                            <Link className="btn" to="#" onClick={addRecord}>
                                <i className="feather-plus" />
                            </Link>
                        </div>
                        <div className="table-responsive table-datatble">
                            <table className="table datatable">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="text-uppercase text-center">Sl No</th>
                                        <th className="text-uppercase text-center">Injury Type</th>
                                        <th className="text-uppercase text-center">Injury Description</th>
                                        <th className="text-uppercase text-center">Date of Injury</th>
                                        <th className="text-uppercase text-center">Injury Severity</th>
                                        <th className="text-uppercase text-center">Region Affected</th>
                                        <th className="text-uppercase text-center">Diagnosis Type</th>
                                        <th className="text-uppercase text-center">Mechanism of Injury</th>
                                        <th className="text-uppercase text-center">Injury Management Approach</th>
                                        <th className="text-uppercase text-center">Time Lost from Training</th>
                                        <th className="text-uppercase text-center">Summary of Treatment</th>
                                        <th className="text-uppercase text-center">Summary of Recovery Process</th>
                                        <th className="text-uppercase text-center">Date of Return to Sports</th>
                                        <th className="text-uppercase text-center">Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(injuryHistory) && injuryHistory.map((injury, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{index + 1}</td>
                                            <td className="text-center">{injury.injuryTypeName}</td>
                                            <td className="text-center">{injury.injuryDescription}</td>
                                            <td className="text-center">{formatDate(injury.dateOfInjury)}</td>
                                            <td className="text-center">{injury.injurySeverityName}</td>
                                            <td className="text-center">{injury.regionAffectedName}</td>
                                            <td className="text-center">{injury.diagnosisTypeName}</td>
                                            <td className="text-center">{injury.mechanismOfInjuryName}</td>
                                            <td className="text-center">{injury.injuryManagementApproachName}</td>
                                            <td className="text-center">{injury.timeLostFromTrainingName}</td>
                                            <td className="text-center">{injury.summaryOfTreatment}</td>
                                            <td className="text-center">{injury.summaryOfRecoveryProcess}</td>
                                            <td className="text-center">{formatDate(injury.dateOfReturnToSports)}</td>
                                            <td className="text-center">{(injury.status == 1) ? "Active" : "Inactive"}</td>
                                            <td>
                                                <Link to="#" onClick={() => editDetails(injury)}>
                                                    <i className="feather-edit" />Edit
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Injury Details</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody><div className="row">
                    <div className="col-lg-4">
                        <label className="form-label">Injury Description</label>
                        <input
                            type="text"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            name="injuryDescription"
                            required
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                            placeholder="Enter Injury Description" />
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Date of Injury</label>
                        <input
                            type="date"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            name="dateOfInjury"
                            required
                            value={injDate}
                            onChange={(e) => setInjDate(e.target.value)}
                            placeholder="Enter Date of injury" />
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Date of return to sports</label>
                        <input
                            type="date"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            name="dateOfReturnToSports"
                            required
                            value={sprtDate}
                            onChange={(e) => setSprtDate(e.target.value)}
                            placeholder="Enter Date of Return" />
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Summary of Treatment</label>
                        <input
                            type="text"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            name="summaryOfTreatment"
                            required
                            value={treatSmry}
                            onChange={(e) => setTreatSmry(e.target.value)}
                            placeholder="Enter Summary of Treatment" />
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Summary of Recovery Process</label>
                        <input
                            type="text"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            name="summaryOfRecoveryProcess"
                            required
                            value={recSmry}
                            onChange={(e) => setRecSmry(e.target.value)}
                            placeholder="Enter Summary of Recover Process" />
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Injury Type</label>
                        <Select
                            value={injuryTypeList.find(inj => inj.injTypId === injTyp) ? {
                                value: injTyp,
                                label: injuryTypeList.find(inj => inj.injTypId === injTyp)?.injTypName
                            } : null}
                            onChange={(e) => setInjTyp(e.value)}
                            required
                            placeholder="Select Injury Type"
                            options={injuryTypeList.map(inj => ({
                                value: inj.injTypId,
                                label: inj.injTypName
                            }))}>
                        </Select>
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Region Affected</label>
                        <Select
                            isMulti
                            value={Array.isArray(affectedRegionList)
                                ? affectedRegionList
                                    .filter(afctd => rgnAfctd.includes(afctd.aftcdRgnId))
                                    .map(afctd => ({
                                        value: afctd.aftcdRgnId,
                                        label: afctd.aftcdRgnName
                                    }))
                                : []
                            }
                            onChange={(selectedOptions) => {
                                // const selectedIds = selectedOptions.map(option => option.value);
                                const selectedIds = Array.isArray(selectedOptions)
                                    ? selectedOptions.map(option => option.value)
                                    : selectedOptions
                                        ? [selectedOptions.value]
                                        : [];
                                setRgnAfctd(selectedIds);
                            }}
                            options={Array.isArray(affectedRegionList)
                                ? affectedRegionList.map(afctd => ({
                                    value: afctd.aftcdRgnId,
                                    label: afctd.aftcdRgnName
                                }))
                                : []
                            }
                        />
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Diagnosis</label>
                        <Select
                            isMulti
                            value={Array.isArray(diagnosisList)
                                ? diagnosisList
                                    .filter(diag => diagnosis.includes(diag.diagnosisId))
                                    .map(diag => ({
                                        value: diag.diagnosisId,
                                        label: diag.diagnosisName
                                    }))
                                : []
                            }
                            onChange={(selectedOptions) => {
                                // const selectedIds = selectedOptions.map(option => option.value);
                                const selectedIds = Array.isArray(selectedOptions)
                                    ? selectedOptions.map(option => option.value)
                                    : selectedOptions
                                        ? [selectedOptions.value]
                                        : [];
                                setDiagnosis(selectedIds);
                            }}
                            options={Array.isArray(diagnosisList)
                                ? diagnosisList.map(diag => ({
                                    value: diag.diagnosisId,
                                    label: diag.diagnosisName
                                }))
                                : []
                            }
                        />
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Injury Severity</label>
                        <Select
                            value={severityList.find(svrty => svrty.severityId === injSvrty) ? {
                                value: injSvrty,
                                label: severityList.find(svrty => svrty.severityId === injSvrty)?.severityName
                            } : null}
                            onChange={(e) => setInjSvrty(e.value)}
                            required
                            placeholder="Select Injury Severity"
                            options={severityList.map(svrty => ({
                                value: svrty.severityId,
                                label: svrty.severityName
                            }))}>
                        </Select>
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Mechanism of Injury</label>
                        <Select
                            value={injuryMechanismList.find(mech => mech.injMechId === injMech) ? {
                                value: injMech,
                                label: injuryMechanismList.find(mech => mech.injMechId === injMech)?.injMechName
                            } : null}
                            onChange={(e) => setInjMech(e.value)}
                            required
                            placeholder="Select Mechanism of Injury"
                            options={injuryMechanismList.map(mech => ({
                                value: mech.injMechId,
                                label: mech.injMechName
                            }))}>
                        </Select>
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Injury Management Approach</label>
                        <Select
                            isMulti
                            value={Array.isArray(injuryMgmtList)
                                ? injuryMgmtList
                                    .filter(mgmt => injMgmt.includes(mgmt.injMgmtId))
                                    .map(mgmt => ({
                                        value: mgmt.injMgmtId,
                                        label: mgmt.injMgmtName
                                    }))
                                : []
                            }
                            onChange={(selectedOptions) => {
                                // const selectedIds = selectedOptions.map(option => option.value);
                                const selectedIds = Array.isArray(selectedOptions)
                                    ? selectedOptions.map(option => option.value)
                                    : selectedOptions
                                        ? [selectedOptions.value]
                                        : [];
                                setInjTyp(selectedIds);
                            }}
                            options={Array.isArray(injuryMgmtList)
                                ? injuryMgmtList.map(mgmt => ({
                                    value: mgmt.injMgmtId,
                                    label: mgmt.injMgmtName
                                }))
                                : []
                            }>
                        </Select>
                    </div>
                    <div className="col-lg-4">
                        <label className="form-label">Time Lost from training/ competition</label>
                        <Select
                            value={timeLostList.find(time => time.timelostId === timeLost) ? {
                                value: timeLost,
                                label: timeLostList.find(time => time.timelostId === timeLost)?.timelostName
                            } : null}
                            onChange={(e) => setTimeLost(e.value)}
                            required
                            placeholder="Select Time Lost"
                            options={timeLostList.map(time => ({
                                value: time.timelostId,
                                label: time.timelostName
                            }))}>
                        </Select>
                    </div>
                </div>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            type="submit"
                            onClick={handleSubmit}
                        >
                            <b><i className="fas fa-save" />Save</b>
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        </>
    );
};

export default InjuryHistory;